import React from 'react';
import { MEDIA_TYPE, MESSAGE_DIRECTION } from '@whatsper/texterchat-common';
import ImageMessage from '../../../../ImageMessage';
import VideoMessage from '../../../../VideoMessage';
const PostPreview = ({ url, type }) => {
    switch (type) {
        case MEDIA_TYPE.IMAGE:
            return (React.createElement(ImageMessage, { messageId: url, media: { url, mediaType: type }, direction: MESSAGE_DIRECTION.OUT, imageMessages: [Object.assign({ url, mediaType: type }, { index: 0 })], showCaption: false }));
        case MEDIA_TYPE.VIDEO:
            return (React.createElement(VideoMessage, { media: { url, mediaType: type }, direction: MESSAGE_DIRECTION.OUT, showCaption: false, shareFile: () => Promise.resolve('') }));
        default:
            return null;
    }
};
export default PostPreview;
